import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppDeclarationCheck } from './app.component';
import { AsiCoreModule } from '@advsol/core';
import { CookieService } from 'ngx-cookie-service';

@NgModule({
  declarations: [
        AppDeclarationCheck
  ],
  imports: [
      BrowserModule,
      AsiCoreModule
  ],
  providers: [CookieService],
    bootstrap: [AppDeclarationCheck]
})
export class AppModule { }
